// ToastV3.tsx
import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

interface ToastV3Props {
  onCancel: () => void;
  onSave: () => void;
  onClose: () => void;
  showReset?: boolean;                            
  type?: 'info' | 'success' | 'warning' | 'error';
  message?: string;                               
  confirmText?: string;                           
  resetText?: string;                           
}

const backgroundColorMap = {
  info:    '#2c2c2c',
  success: '#2e7d32',
  warning: '#f57c00',
  error:   '#d32f2f',
};

export const ToastV3: React.FC<ToastV3Props> = ({
  onCancel,
  onSave,
  onClose,
  showReset = true,
  type = 'info',
  message,
  confirmText,
  resetText,
}) => {
  // your existing defaults:
  const defaultMsg    = type === 'success' ? 'Saved successfully!' : 'You have unsaved changes';
  const defaultConfirm = 'Save';
  const defaultReset   = 'Reset';

  const displayMessage = message ?? defaultMsg;
  const confirmLabel   = confirmText ?? defaultConfirm;
  const resetLabel     = resetText   ?? defaultReset;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: backgroundColorMap[type],
        color: 'white',
        py: 1.2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1300,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <ReportProblemOutlinedIcon fontSize="small" />
        <Typography>{displayMessage}</Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        {showReset && (
          <Button
            onClick={onCancel}
            color="inherit"
            variant="outlined"
            size="small"
          >
            {resetLabel}
          </Button>
        )}
        <Button
          onClick={onSave}
          color="inherit"
          variant="outlined"
          size="small"
        >
          {confirmLabel}
        </Button>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ color: 'white' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
